// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1ba109870288d6abe5cc","655":"5d4fc195d696a1c4856b"}[chunkId] + ".js";
};